"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoComponent = LogoComponent;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var logo_mark_png_1 = __importDefault(require("../../assets/logo/logo-mark.png"));
var logo_png_1 = __importDefault(require("../../assets/logo/logo.png"));
function LogoComponent(props) {
    var _a = props.size, size = _a === void 0 ? 56 : _a, _b = props.variant, variant = _b === void 0 ? "full" : _b, navigateTo = props.navigateTo;
    var navigate = (0, react_router_dom_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)("img", { alt: "CannaLedger logo", src: variant === "mark" ? logo_mark_png_1.default : logo_png_1.default, width: size, className: "h-auto object-contain ".concat(navigateTo ? "cursor-pointer" : ""), onClick: function () {
            if (navigateTo) {
                navigate(navigateTo);
            }
        } }));
}
